import $ from 'jquery';
import Noty from 'noty';

import waitMe from './waitMe.min.js';
import moment from 'moment';
// import moment from 'moment-timezone'
import Hashids from 'hashids'
import { mounted } from 'vue2-dropzone';
import { create } from 'lodash';

waitMe($);

/*
$.ajaxSetup({
	headers:{
		'Api-Token': process.env.VUE_APP_API_TOKEN,
		'Access-Control-Allow-Origin': '*'
	}
});

var base_url=process.env.VUE_APP_API_URL;
*/

export default {

	data() {
		return {
			base_url: '',
			pagination: {
				currentPage: 1,
				totalRows: 0,
				perPage: 50,
				slOffset: 1
			},
			paginationCustom: {
				currentPage: 1,
				totalRows: 0,
				perPage: 10,
				slOffset: 1
			},
			paginationVerified: {
				currentPage: 1,
				totalRows: 0,
				perPage: 10,
				slOffset: 1
			},
			paginationUnverified: {
				currentPage: 1,
				totalRows: 0,
				perPage: 10,
				slOffset: 1
			},
			countryList: [],
			monthList: [
				{ id: 1, label: 'January' },
				{ id: 2, label: 'February' },
				{ id: 3, label: 'March' },
				{ id: 4, label: 'April' },
				{ id: 5, label: 'May' },
				{ id: 6, label: 'June' },
				{ id: 7, label: 'July' },
				{ id: 8, label: 'August' },
				{ id: 9, label: 'September' },
				{ id: 10, label: 'October' },
				{ id: 11, label: 'November' },
				{ id: 12, label: 'December' },
			],
			yearList: [
				{ id: 1, label: '2019' },
				{ id: 2, label: '2020' },
				{ id: 3, label: '2021' },
				{ id: 4, label: '2022' },
				{ id: 5, label: '2023' },
				{ id: 6, label: '2024' },
				{ id: 7, label: '2025' }
			],
			verificationStatusList: [
				{ id: 'verified', label: 'Verified' },
				{ id: 'unverified', label: 'Unverified' },
			],
			issueStatusList: [
				{ value: 'all', text: 'All' },
				{ value: 'with_issue', text: 'In Progress' },
				{ value: 'no_issue', text: 'Completed' },
			],
			fundingSourceList: [
				{ id: 'Sponsored', label: 'Sponsored' },
				{ id: 'Self Funded', label: 'Self Funded' },
			],
			taskStatusList: [
				{ id: 0, label: 'Pending' },
				{ id: 1, label: 'Ongoing' },
				{ id: 2, label: 'Completed' }
			],
			agreementRenewableOption: [
				{
					value: 1,
					text: 'Yes',
				},
				{
					value: 0,
					text: 'No',
				}
			],
			recruitmentMarketTypeList: [
				{
					value: 0,
					text: 'Global',
				},
				{
					value: 2,
					text: 'Region',
				},
				{
					value: 1,
					text: 'Country',
				}
			],
			uniInfo: {
				title: "Agent Commission Management System",
				description: "Agent Commission Management System",
			}
		}
	},
	computed: {
		auth_user: function () {
			return this.cn(this.$store.state, 'site.auth_user', null);
		},

	},
	methods: {
		
		no_img: function (uri = 'assets/img/placeholder.png') {
			return this.url(uri);
		},
		is_valid_base_url: function (value) {

			if (value === null || value === undefined) {
				return false;
			}

			var s = String(value).trim();

			if (!s || s === 'undefined' || s === 'null') {
				return false;
			}

			if (/\/undefined(\/|$)/.test(s) || /^undefined(\/|$)/.test(s)) {
				return false;
			}

			return true;

		},
		normalize_base_url: function (value) {

			if (!this.is_valid_base_url(value)) {
				return '';
			}

			return String(value).trim().replace(/\/$/, '');

		},
		read_base_url_from_dom: function () {

			var nodes = [];

			if (this.$root && this.$root.$el) {
				nodes.push(this.$root.$el);
			}

			if (typeof document !== 'undefined') {
				var agentEl = document.querySelector('sams-pay-agent');
				var uniEl = document.querySelector('sams-pay-uni');
				if (agentEl) {
					nodes.push(agentEl);
				}
				if (uniEl) {
					nodes.push(uniEl);
				}
			}

			for (var i = 0; i < nodes.length; i++) {
				var el = nodes[i];
				if (!el || !el.getAttribute) {
					continue;
				}
				var fromAttr = el.getAttribute('base-url') || el.getAttribute('base_url');
				var normalized = this.normalize_base_url(fromAttr);
				if (normalized) {
					return normalized;
				}
			}

			return '';

		},
		read_base_url_from_root_component: function () {

			var root = this.$root;
			if (!root || !root.$children || !root.$children.length) {
				return '';
			}

			for (var i = 0; i < root.$children.length; i++) {
				var child = root.$children[i];
				if (!child) {
					continue;
				}
				var fromProp = child.baseUrl || child.base_url;
				var normalized = this.normalize_base_url(fromProp);
				if (normalized) {
					return normalized;
				}
				var attrs = child.$attrs || {};
				normalized = this.normalize_base_url(attrs['base-url'] || attrs.base_url);
				if (normalized) {
					return normalized;
				}
			}

			return '';

		},
		assign_local_base_url: function (normalized) {

			this.base_url = normalized;

		},
		persist_app_base_url: function (baseUrl) {

			var normalized = this.normalize_base_url(baseUrl);
			if (!normalized) {
				return '';
			}

			if (this.$store) {
				this.$store.commit('setBaseUrl', normalized);
			}

			this.assign_local_base_url(normalized);

			try {
				localStorage.setItem('base_url', normalized);
			} catch (e) {
				// ignore storage errors
			}

			return normalized;

		},
		resolve_app_base_url: function () {

			var candidates = [
				this.read_base_url_from_dom(),
				this.read_base_url_from_root_component(),
				this.baseUrl,
				this.base_url,
			];

			if (this.$store && this.$store.state && this.$store.state.base_url) {
				candidates.push(this.$store.state.base_url);
			}

			try {
				var storedBase = localStorage.getItem('base_url');
				if (storedBase) {
					candidates.push(storedBase);
				}
			} catch (e) {
				// ignore storage errors
			}

			if (typeof window !== 'undefined' && window.location && window.location.origin) {
				candidates.push(window.location.origin);
			}

			for (var i = 0; i < candidates.length; i++) {
				var normalized = this.normalize_base_url(candidates[i]);
				if (normalized) {
					return normalized;
				}
			}

			try {
				var badStored = localStorage.getItem('base_url');
				if (badStored && !this.is_valid_base_url(badStored)) {
					localStorage.removeItem('base_url');
				}
			} catch (e) {
				// ignore storage errors
			}

			return '';

		},
		url: function (path, base_url = null) {

			if (!base_url || base_url === 'undefined' || base_url === 'null') {
				base_url = this.resolve_app_base_url();
			}

			path = String(path || '').replace(/^\//, '');
			path = path.replace(/^undefined\/?/, '');
			base_url = this.normalize_base_url(base_url);

			if (!base_url) {
				return '/' + path;
			}

			return `${base_url}/${path}`;

		},
		apiUrl: function (path) {
			return `${this.api_url}/${path}`;
		},
		jq: function () {
			return $;
		},
		alert: function (msg = 'No message specified', type = 'success', callback = null) {

			if (!msg) return null;

			new Noty({
				theme: 'sunset',
				text: msg,
				type: type,
				timeout: 3000,
				callbacks: {
					afterClose: callback
				}
			}).show();

		},
		// err_msg: function (err) {

		// 	//console.log(err.status);

		// 	if (err.status && err.status == 401) {

		// 		this.$router.push('/logout');
		// 		return null;

		// 	}

		// 	var msg = "Request failed to process, try again later.";

		// 	if (err.responseJSON && err.responseJSON.msg) {
		// 		msg = err.responseJSON.msg;
		// 	} else if (err.message) {
		// 		msg = err.message;
		// 	}

		// 	return msg;

		// },
		err_msg: function (err, options) {
			options = options || {};
			var status = err.status || (err.response && err.response.status);
			var responseMsg = '';
			if (err.responseJSON && err.responseJSON.msg) {
				responseMsg = err.responseJSON.msg;
			} else if (err.response && err.response.data && err.response.data.msg) {
				responseMsg = err.response.data.msg;
			} else if (err.responseJSON && err.responseJSON.message) {
				responseMsg = err.responseJSON.message;
			}

			// Access denied is not a session logout
			if (status == 403) {
				if (responseMsg) {
					return responseMsg;
				}
				return 'You do not have access to perform this action.';
			}

			if (status && (status == 401 || status == 419) && !options.skip_auth_redirect) {
				var requestUrl = '';
				try {
					var config = (err.response && err.response.config) || err.config || null;
					if (config && config.url) {
						requestUrl = String(config.url);
					} else if (err.responseURL) {
						requestUrl = String(err.responseURL);
					} else if (err.settings && err.settings.url) {
						requestUrl = String(err.settings.url);
					}
				} catch (e) {
					// ignore parse errors
				}

				// Detect if the 401 came from the Support API so we avoid global logout
				var isSupportError = false;
				try {
					const supportToken = localStorage.getItem('supportApiToken');
					const config = (err.response && err.response.config) || err.config || null;
					const supportInfoRaw = localStorage.getItem('support_info');
					if (supportInfoRaw) {
						const supportInfo = JSON.parse(supportInfoRaw);
						if (supportInfo && supportInfo.base_url && requestUrl.indexOf(supportInfo.base_url) !== -1) {
							isSupportError = true;
						}
						if (config && supportInfo && supportInfo.base_url && config.baseURL && String(supportInfo.base_url) === String(config.baseURL)) {
							isSupportError = true;
						}
					}
					const authHeader = config && config.headers && (config.headers.Authorization || config.headers.authorization);
					if (!isSupportError && authHeader && supportToken && authHeader === 'Bearer ' + supportToken) {
						isSupportError = true;
					}
				} catch (e) {
					// ignore parse errors
				}

				if (isSupportError) {
					return responseMsg || null;
				}

				// Background widgets must not wipe the main session
				var softAuthEndpoints = [
					'get_bell_notifications',
					'get_unread_comment_count_data',
					'get_all_bell_notifications',
					'get_list_comm_count',
				];
				var isSoftEndpoint = softAuthEndpoints.some(function (ep) {
					return requestUrl.indexOf(ep) !== -1;
				});

				if (isSoftEndpoint) {
					return responseMsg || 'Session could not be verified for this request.';
				}

				// Only treat explicit session bootstrap as global logout (not every gateway/ajax 401)
				var sessionBootstrapEndpoints = [
					'auth_user_info',
					'auth/check',
					'auth/logout',
				];
				var isSessionBootstrap = sessionBootstrapEndpoints.some(function (ep) {
					return requestUrl.indexOf(ep) !== -1;
				});

				if (isSessionBootstrap || options.force_session_logout) {
					this.$router.push('/logout');
					return null;
				}

				var authToast = String(responseMsg || '').toLowerCase();
				if (
					!responseMsg
					|| authToast === 'unauthenticated.'
					|| authToast === 'unauthenticated'
					|| authToast.indexOf('could not be authenticated') !== -1
					|| authToast.indexOf('session could not be verified') !== -1
				) {
					return null;
				}

				return responseMsg;
			}

			var msg = "Request failed to process, try again later.";

			if (err.responseJSON && err.responseJSON.msg) {
				msg = err.responseJSON.msg;
			} else if (err.message) {
				msg = err.message;
			}

			return msg;

		},
		catch_alert: async function (err, callback = null) {

			this.alert(err.message, 'error', callback);

		},
		cn: function (obj, input, if_false = '') {

			var elements = input.split('.');

			for (var i = 0; i < elements.length; i++) {

				if (!obj || !obj[elements[i]]) {

					return if_false;

				}

				obj = obj[elements[i]];
			}

			if (obj) return obj;
			return if_false;

		},
		ajax_setup: function (token_name = 'api_token') {

			var ref = this;
			var api_token = ref.api_token || (ref.$store && ref.$store.state.api_token) || '';

			// Never mix uni + agent tokens — wrong guard causes 401 on all API calls after auth_user_info
			if (token_name === 'uni_api_token') {
				api_token = localStorage.getItem('uni_api_token') || api_token;
			} else if (token_name === 'agent_api_token') {
				api_token = localStorage.getItem('agent_api_token') || api_token;
			} else {
				var storageKeys = [token_name, 'uni_api_token', 'agent_api_token', 'api_token'];
				for (var i = 0; i < storageKeys.length; i++) {
					var key = storageKeys[i];
					if (!key) {
						continue;
					}
					var stored = localStorage.getItem(key);
					if (stored) {
						api_token = stored;
						break;
					}
				}
			}

			var headers = {
				'Accept': 'application/json',
				'Access-Control-Allow-Origin': '*',
				'APP-Key':'$3tygdsjbkgba08adkghasdghaksdgnkalsdghasdhg$#kasdbsdjogbvad08gq'
			};

			if (api_token) {
				headers['Authorization'] = 'Bearer ' + api_token;
			}

			ref.jq().ajaxSetup({
				headers: headers
			});

		},
		limit_str: function (str, limit = 20, alt_str = '...') {

			if (str && str.length) {
				return str.length > limit ? str.substring(0, limit - 3) + alt_str : str;
			} else return '';

		},
		wait_me: function (selector, config = null) {

			var jq = this.jq();

			if (config) {

				jq(selector).waitMe(config);

			} else {

				jq(selector).waitMe({
					effect: 'facebook',
					//color: '#000',
					text: 'Please! Wait ...'
				});

			}

		},
		clone: function (value) {

			return Object.assign({}, value);

		},
		is_agent_portal: function () {
			if (typeof window === 'undefined') {
				return false;
			}
			return window.location.pathname.indexOf('/agent') !== -1;
		},
		is_uni_portal: function () {
			if (typeof window === 'undefined') {
				return false;
			}
			var path = window.location.pathname;
			return path.indexOf('/uni') !== -1 || path.indexOf('/university') !== -1;
		},
		setup_urls: function () {
			var resolvedBase = this.persist_app_base_url(this.resolve_app_base_url());
			if (!resolvedBase && this.$store && this.is_valid_base_url(this.$store.state.base_url)) {
				this.assign_local_base_url(this.normalize_base_url(this.$store.state.base_url));
			}
			this.api_token = this.$store.state.api_token;
			if (this.is_agent_portal() && localStorage.getItem('agent_api_token')) {
				this.ajax_setup('agent_api_token');
			} else if (this.is_uni_portal() && localStorage.getItem('uni_api_token')) {
				this.ajax_setup('uni_api_token');
			} else if (localStorage.getItem('uni_api_token')) {
				this.ajax_setup('uni_api_token');
			} else if (localStorage.getItem('agent_api_token')) {
				this.ajax_setup('agent_api_token');
			} else {
				this.ajax_setup('uni_api_token');
			}
			//this.api_url=this.$store.state.api_url;
			//this.api_key=this.$store.state.api_key;
		},
		aws_attachment_download_url: function (attachment) {
			if (attachment && attachment.id) {
				return this.url('download/aws-media/' + attachment.id);
			}
			if (attachment && attachment.file) {
				return this.url('tmp_aws_media/' + attachment.file);
			}
			return '#';
		},
		str_title: function (str) {

			return str.replace(
				/\w\S*/g,
				function (txt) {
					return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
				}
			);

		},
		//Ruhul amin vai told you to make a component of this.
		paginationData(data) {
			this.pagination.currentPage = data.current_page
			this.pagination.totalRows = data.total
			this.pagination.perPage = data.per_page
			this.pagination.slOffset = data.per_page * this.pagination.currentPage - data.per_page + 1
		},
		paginationCustomData(data) {
			this.paginationCustom.currentPage = data.current_page
			this.paginationCustom.totalRows = data.total
			this.paginationCustom.perPage = data.per_page
			this.paginationCustom.slOffset = data.per_page * this.paginationCustom.currentPage - data.per_page + 1
		},
		paginationVerifiedData(data) {
			this.paginationVerified.currentPage = data.current_page
			this.paginationVerified.totalRows = data.total
			this.paginationVerified.perPage = data.per_page
			this.paginationVerified.slOffset = data.per_page * this.paginationVerified.currentPage - data.per_page + 1
		},
		paginationUnverifiedData(data) {
			this.paginationUnverified.currentPage = data.current_page
			this.paginationUnverified.totalRows = data.total
			this.paginationUnverified.perPage = data.per_page
			this.paginationUnverified.slOffset = data.per_page * this.paginationUnverified.currentPage - data.per_page + 1
		},
		checkCurrentDateLessThenDate: function (dateValue) {
			const currentDate = this.dDate(new Date(), 'YYYY-MM-DD')
			const anotherDate = this.dDate(dateValue, 'YYYY-MM-DD')
			if (anotherDate > currentDate) {
				return true
			} else {
				return false
			}
		},
		checkCurrentDateGreaterThenDate: function (dateValue) {
			const currentDate = this.dDate(new Date(), 'YYYY-MM-DD')
			const anotherDate = this.dDate(dateValue, 'YYYY-MM-DD')
			if (anotherDate < currentDate) {
				return true
			} else {
				return false
			}
		},
		dDate: function (value, format = 'D MMM  YYYY') {
			return moment.utc(value).local().format(format)
		},
		dDateTime: function (value, format = 'D MMM  YYYY LT') {
			return moment.utc(value).local().format(format)
		},
		dTime: function (value, format = 'LT') {
			return moment.utc(value).local().format(format)
		},
		dMonth: function (value, format = 'MMM  YYYY') {
			return moment(value).format(format)
		},
		dYear: function (value, format = 'YYYY') {
			return moment(value).format(format)
		},
		dNow: function (value) {
			// return moment(value).fromNow()
			return moment.utc(value).local().fromNow()
		},
		integer: function (value = 0) {
			const integerValue = value | 0
			return Number(integerValue).toLocaleString()
		},
		float: function (value = 0.00) {
			if (value) {
				const integerValue = parseFloat(value)
				return Number(integerValue).toLocaleString()
			} else {
				return 0
			}
		},
		float2: function (value = 0.00) {
			if (value) {
				const double = parseFloat(value).toFixed(2)
				return Number(double).toLocaleString()
			} else {
				return 0
			}
		},
		nf: function (value = 0.00) {
			if (value) return parseFloat(value).toFixed(2);
			else return 0.00;
		},
		nf_pound: function (value = 0.00, digits=2) {
			if (value) {
				const num = parseFloat(value);
				if (isNaN(num)) return (0).toFixed(digits);
				return num.toLocaleString(undefined, {
					minimumFractionDigits: digits,
					maximumFractionDigits: digits
				});
			}
			return "0.00";
		},
		pureInt: function (value = 0.00) {
			if (value) {
				return parseInt(value)
			} else {
				return 0;
			}
		},
		hash_id: function (value, encode = true) {
			var hashids = new Hashids('hashids_for_passing_url_id', 32);
			if (encode) {
				return hashids.encode(value);
			} else {
				return hashids.decode(value);
			}
		},
		check_uni_auth: async function () {

			var ref = this;
			var api_token = localStorage.getItem('uni_api_token');

			if (!api_token) {
				ref.$router.push('/login');
				return;
			}

		},
		avatarText: function (value) {
			var matches = value.match(/\b(\w)/g);

			if (matches.length == 1) {
				return value.substring(0, 2).toLocaleUpperCase()
			} else {
				const data = matches.filter((item, index) => {
					if (index < 2) {
						return Object.assign({}, item)
					}
				})
				return data.join('');
			}
		},
		countries: async function () {

			var ref = this;
			var jq = ref.jq();
			try {
				var res = await jq.get(ref.url('api/v1/common/ajax/countries'));
				return res.data.countries;

			} catch (err) {
				ref.alert(ref.err_msg(err), 'error');
			}

		},
		random_number: function (limit = 10) {
			return Math.floor(Math.random() * (limit + 1));
		},
		remove_row: function (array_data, index) {

			if (index > -1) array_data.splice(index, 1);

		},
		img_on_error: function (ev) {
			ev.target.src = 'https://placehold.co/150?text=No+Image';
		},
		img_on_error_logo: function (ev) {
			ev.target.src = 'https://placehold.co/200x40?text=Your+Logo';
		},
		imageRenderer: function (inputEl, callback) {
			const inputImageRenderer = () => {
				const file = inputEl.value.files[0]
				const reader = new FileReader()

				reader.addEventListener(
					'load',
					() => {
						callback(reader.result)
					},
					false,
				)

				if (file) {
					reader.readAsDataURL(file)
				}
			}
			return {
				inputImageRenderer,
			}
		},
		permission_check: function (permit_code) {
			const permission_disable = this.$store.state.site.permission_disable
			if (permission_disable) {
				// Deny-flags like not_add_list_manager must stay false when access is unrestricted,
				// otherwise Super Admin hides UI that uses !permission_check('not_...')
				if (permit_code && String(permit_code).indexOf('not_') === 0) {
					return false
				}
				return true
			} else {
				if (permit_code) {
					if (permit_code == 'permitted') {
						return true
					} else {
						const permissions = this.$store.state.site.permissions
						if (permissions && permissions.length) {
							const userPermission = permissions.find(permission => permission == permit_code)
							return userPermission == undefined ? false : true
						} else {
							return false
						}
					}
				} else {
					return false
				}
			}
		},
		/**
		 * Assign LM colleagues:
		 * - Super/System admin: always
		 * - list_manager permit: yes
		 * - not_add_list_manager (assigned LM): no
		 * - everyone else: no
		 */
		can_assign_list_manager: function () {
			const site = this.$store.state.site || {}
			if (site.permission_disable) {
				return true
			}
			const roleCode = this.cn(site, 'auth_user.user_role.role.role_code', null)
			if (roleCode === 'super_admin' || roleCode === 'system_admin') {
				return true
			}
			const raw = site.permissions || []
			const list = Array.isArray(raw) ? raw : Object.values(raw)
			if (list.indexOf('not_add_list_manager') !== -1) {
				return false
			}
			return list.indexOf('list_manager') !== -1
		},
		/**
		 * Agent-wise student list page (/one, /two):
		 * role international_office / agent_wise_students OR LM colleague on this list.
		 */
		can_view_agent_wise_student_list: function () {
			if (
				this.permission_check('international_office')
				|| this.permission_check('agent_wise_students')
				|| this.permission_check('intake_wise_agents')
				|| this.permission_check('gateway')
			) {
				return true
			}
			var listId = this.list_id
			if (!listId && this.$route && this.$route.params && this.$route.params.id) {
				var decoded = this.hash_id(this.$route.params.id, false)
				listId = decoded && decoded[0] ? decoded[0] : null
			}
			if (!listId) {
				return false
			}
			var managed = this.cn(this.$store.state, 'site.managed_list_ids', []) || []
			if (!Array.isArray(managed)) {
				managed = Object.values(managed)
			}
			return managed.map(Number).indexOf(Number(listId)) !== -1
		},
		chunk: function (arr, len) {

			var chunks = [],
				i = 0,
				n = arr.length;

			while (i < n) {
				chunks.push(arr.slice(i, i += len));
			}

			return chunks;
		},
		humanize: function (str) {
			var i, frags = str.split('_');
			for (i = 0; i < frags.length; i++) {
				frags[i] = frags[i].charAt(0).toUpperCase() + frags[i].slice(1);
			}
			return frags.join(' ');
		},
		goto: function (uri) {
			this.$router.push(uri);
		},
		genYearList: function(){

			const currentYear = new Date().getFullYear();
			const years = [];

			for(let year = currentYear - 4; year <= currentYear + 4; year++){
				years.push({
					id: year,
					label: year
				});
			}

			return years;

		}
	}, //End of method,
	// mounted() {
	// 	cn(this.$store.state.site, 'university.name', 'Loading...') = this.cn(this.$store.state, 'site.university.name', 'Loading...');
	// }
}